import { Box } from '@chakra-ui/react';
import { FC } from 'react';
import { ErrorAssets } from 'src/config';

interface IGameIcon {
	url: string;
}

export const GameIcon: FC<IGameIcon> = ({ url }) => {
	return (
		<Box
			backgroundColor="#1C1B1B"
			bg={`url(${url !== '' ? url : ErrorAssets.invalidIcon})`}
			bgSize="cover"
			bgPos="center"
			borderRadius="5px"
		/>
	);
};
